import { Component, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PayeePopupComponent } from '../../../shared/payee-popup/payee-popup.component';

type LockableBankAccountControls = {
  lock_bank_account: FormControl<boolean | null>;
};

export type LockBankAccountDialogData = {
  bank_account: FormGroup<LockableBankAccountControls>;
};

@Component({
  selector: 'app-lock-bank-account-dialog',
  templateUrl: './lock-bank-account-dialog.component.html',
  styleUrls: ['./lock-bank-account-dialog.component.scss'],
  imports: [PayeePopupComponent],
})
export class LockBankAccountDialogComponent {
  private dialogRef =
    inject<MatDialogRef<LockBankAccountDialogComponent>>(MatDialogRef);

  data = inject<LockBankAccountDialogData>(MAT_DIALOG_DATA);

  readonly submit = () => {
    const b = this.data.bank_account;
    b.controls.lock_bank_account.patchValue(true);
    b.enable();
    this.dialogRef.close();
  };

  readonly cancel = () => {
    this.dialogRef.close();
  };
}
